import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../utils/breakpoints";

const StyledDiv = styled.div`
	position: relative;
	width: 100%;
	margin: auto;
	font: normal normal normal 1.25vw/2vw Nexa-light;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	



	.benefit-container {
		color: #ffffff;
			background: #35393F; no-repeat padding-box;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		padding: 10px;
		border-radius: 8px;
		

		img {
			height: 75px;
			width: 75px;
		}
	}

	@media screen and ${breakpoints.device.tablet} {
		font-size: 2vw;
		line-height: 1;
	}

	@media screen and ${breakpoints.device.mobileL} {
		width: 100%;
		height: 30vw;
		font-size: 4vw;
		

		:first-child{
			grid-column: auto;
		}

		

		.benefit-container .benefit-icon {
			width: 20vw;
			margin: auto;

			img {
				height: 75px;
				width: 75px;
			}
		}
	}
`;

const Benefit = ({ icon, txt }) => {
	return (
		<StyledDiv>
			<div id={window.innerWidth > 650 ? "NoMobileOpp" : ""}>
				<div className="benefit-container" >
				<div className="benefit-icon">{icon}</div>
				<div className="benefit-txt">{txt}</div>
				</div>
			</div>
		</StyledDiv>
	);
};

export default Benefit;
